module.exports = __webpack_public_path__ + "img/checked.347874f5.svg";